import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/system';


const StyledDetails = styled('details')(({ theme }) =>({
    cursor: 'pointer',
    borderTop: '1px solid #dcdcdc',
    borderLeft: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    transition: 'max-height 400ms ease-out',
    "&[open]": {
        borderBottom: '1px solid #a9a9a9',
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px",
        marginBottom: 10,
    },
    "> summary": {
        listStyleType: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '12px 15px 11px 15px',
    },
    "&[open] > summary": {
        borderBottom: '1px solid #dcdcdc',
        paddingTop: 20,
        paddingBottom: 20,
    },
    "&:last-of-type": {
        borderBottom: '1px solid #a9a9a9',
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px",
    },
    "& > summary::after": {
        content: '""',
        background: 'url("/static/img/arrow_down_gray.png")',
        backgroundSize: 'cover',
        width: 15,
        height: 15,
        minWidth: 15,
        marginTop: 5,
        marginRight: 10,
        transition: '0.2s',
    },
    "&[open] > summary::after": {
        transform: 'rotate(180deg)',
    },
    "&[open]::details-content": {
        padding: '10px 15px 15px 15px',
    },
}));


class CustomAccordion extends React.Component {

    constructor(props) {
        super(props);
    }

    checkOpen = (event) => {
        if (this.props.onOpenCallback && event.target.open) {
            this.props.onOpenCallback();
        }
    };

    render() {
        return (
            <StyledDetails onToggle={(event) => this.checkOpen(event)} data-bt={this.props.dataBt}>
                <summary>{this.props.summary}</summary>
                <div>{this.props.content}</div>
            </StyledDetails>
        );
    }
}

CustomAccordion.propTypes = {
    summary: PropTypes.node,
    content: PropTypes.node,
    dataBt: PropTypes.string,
    onOpenCallback: PropTypes.func
};

export default CustomAccordion;
